import { Platform } from '@angular/cdk/platform';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: '[app-tag-manager-container]',
    templateUrl: './tag-manager-container.component.html',
    styleUrls: ['./tag-manager-container.component.css'],
    standalone: true,
})
export class TagManagerContainerComponent implements OnInit {
    @Input() apiKey: string;
    @Input() showCookieBanner = false;

    constructor(
        private renderer2: Renderer2,
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platform: Platform,
        private route: ActivatedRoute,
    ) { }

    ngOnInit(): void {
        if(!isPlatformBrowser(this.platform)) return;
        if(this.apiKey) {
            this.addContainerScript(this.apiKey);
        }

        if(!this.route.snapshot?.data?.editMode && !this.apiKey || (this.apiKey && this.showCookieBanner)) {
            window['cookieconsent'] && window['cookieconsent'].run({ "notice_banner_type": "simple", "consent_type": "express", "palette": "light", "language": "en", "website_name": "Voyse", "change_preferences_selector": "#changePreferences", "cookies_policy_url": "http://www.voyse.co.uk/privacy" });
        }
    }

    private addContainerScript(apiKey: string) {
        const exists = this.document.getElementById('gtm-client-container');
        if(exists) return;

        const gtmScript = this.renderer2.createElement('script');
        gtmScript.type = 'text/javascript';
        gtmScript.id   = 'gtm-client-container';
        gtmScript.text = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${apiKey}');`;
        if(this.showCookieBanner) {
            gtmScript.type = 'text/plain';
            gtmScript.setAttribute('data-cookie-consent','targeting');
        }
        this.renderer2.appendChild(this.document.body, gtmScript);
    }
}
